import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './signupstyles.css'; 
import supabase from '../supabaseClient'; 

const SignUpData = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const navigate = useNavigate();

  const handleSignUp = async (e) => {
    e.preventDefault();
  
    // Validation
    if (password.length < 5) {
      setMessage('Password must be at least 5 characters long.');
      return;
    }
  
    if (password !== confirmPassword) {
      setMessage('Passwords do not match.');
      return;
    }
  
    setLoading(true);
  
    // Check if email is already registered
    const { data: userCheck, error: userCheckError } = await supabase
      .from('profiles')
      .select('email')
      .eq('email', email);
  
    if (userCheckError) {
      setMessage(`Error checking email: ${userCheckError.message}`);
      setLoading(false);
      return;
    }
  
    if (userCheck && userCheck.length > 0) {
      setMessage('Email is already registered.');
      setLoading(false);
      return;
    }
  
    // Sign up the user in auth.users
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
    });
  
    if (error) {
      setMessage(`Error creating user: ${error.message}`);
      setLoading(false);
      return;
    }
  
    // Insert additional details into profiles
    const { error: profileError } = await supabase
      .from('profiles')
      .update(
        {
          
          first_name: firstName,
          last_name: lastName,
        
          phone: phone,
        }
      ).eq('user_id', data.user.id);
  
    if (profileError) {
      setMessage(`Sign-up successful, but failed to save profile: ${profileError.message}`);
    } else {
      setMessage('Sign-up successful! Please check your email to confirm your account.');
      navigate('/'); // Redirect to the home page
    }
  
    setLoading(false);
  };
  

  return (
    <div className="signup-container">
      <h2 className="signup-title">Create Your Account</h2>
      <form onSubmit={handleSignUp} className="signup-form">
        <input
          type="text"
          placeholder="First Name"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          required
          className="signup-input"
        />
        <input
          type="text"
          placeholder="Last Name"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          required
          className="signup-input"
        />
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="signup-input"
        />
        <input
          type="tel"
          placeholder="Phone Number"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          required
          className="signup-input"
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className="signup-input"
        />
        <input
          type="password"
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
          className="signup-input"
        />
        <button type="submit" className="signup-button" disabled={loading}>
          {loading ? 'Signing Up...' : 'Sign Up'}
        </button>
      </form>
      {message && <p className="signup-message">{message}</p>}
      
      <p className="signup-login-link">
        Already have an account? <Link to="/login">Sign in here</Link>
      </p>
    </div>
  );
};

export default SignUpData;
